import {FC, useState} from "react";
import {Card, Table} from "react-bootstrap";
import Loader from "@/components/common/loader/loader";
import UseLaunchKeyDates from "@oldDashboard/legacyHooks/useLaunchKeydates";
import { LaunchKeyDates } from "@oldDashboard/legacyModels/launchKeyDates.model";
import { getFiltersDate } from "@oldDashboard/legacyUtils";
import { TimePeriods } from "@oldDashboard/legacyModels/timePeriods.model";

interface LauncKeyDatesSummaryProps  { data: LaunchKeyDates, timePeriods: TimePeriods[], affiliateSelected: any, launchSelected: String, timePeriodSelected: string, searching: boolean}
const LauncKeyDatesSummary: FC<LauncKeyDatesSummaryProps> = ({data, timePeriods, affiliateSelected, launchSelected, timePeriodSelected, searching}) => {
    const { startDate, endDate } = getFiltersDate(timePeriods,timePeriodSelected);
    const [sort, setSort] = useState("when");
    const { isLoading, fetchLaunchesKeyDates } = UseLaunchKeyDates({affiliateSelected, launchSelected, timePeriodSelected, startDate, endDate, sort, searching});
   
    const filterTable = (filter: string) => {
        setSort(filter);
        fetchLaunchesKeyDates(filter);
    }

    return (
        <Card className="custom-card overflow-hidden position-relative" style={{height: '250px'}}>
            { isLoading && <Loader/> }
            <Card.Header className="justify-content-between">
                <Card.Title>
                    Key Dates
                </Card.Title>
            </Card.Header>
            <Card.Body className="p-0 overflow-hidden">
                <div className="table-responsive overflow-scroll" style={{height:"190px"}}>
                    <Table className="table text-nowrap"  style={{tableLayout:"fixed"}}>
                        <thead>
                            <tr>
                            {
                                data.header.map((item, index) => 
                                <th className="position-sticky fixed-top" key={index} onClick={()=>{filterTable(item.caption.toLocaleLowerCase())}}>
                                    {item.caption} { sort == item.caption.toLocaleLowerCase() && <i className="bi bi-sort-up fs-14"></i>}
                                </th>
                            )}
                            </tr>
                        </thead>
                        <tbody>
                            {
                                data.data.map((item, index) => 
                                <tr key={index}>
                                    <>
                                        <td className="text-wrap">{item.date}</td>
                                        <td className="text-wrap">{item.type}</td>
                                        <td className="text-wrap">{item.when}</td>
                                    </>
                                </tr>
                            )
                            }
                        </tbody>
                    </Table>
                </div>
            </Card.Body>
        </Card>
    );
};

export default LauncKeyDatesSummary;
